const de = {
  eyebrow: "FAQ",
  title: "Häufige Fragen",

  items: [
    {
      q: "Welche Kurse bieten Sie an?",
      a: "Wir bieten Live-Kurse mit viel Interaktion in Programmierung und Software-Engineering an: KI und maschinelles Lernen, Algorithmenentwurf, Programmiergrundlagen, Softwarearchitektur, Webentwicklung, mobile Entwicklung sowie Datenbank- und Serverentwicklung, vom Anfänger bis zum Fortgeschrittenen.",
    },
    {
      q: "Brauche ich Vorkenntnisse, um teilzunehmen?",
      a: "Vorkenntnisse sind nicht erforderlich. Unsere Kurse eignen sich für alle Niveaus, von absoluten Anfängern bis zu erfahrenen Programmierern. Sie können bei null anfangen, und wir begleiten Sie Schritt für Schritt.",
    },
    {
      q: "Wie laufen die Kurse ab?",
      a: "Alle Kurse finden live online statt und werden von erfahrenen Dozenten geleitet. Die Sitzungen sind interaktiv, mit praktischen Projekten und Feedback in Echtzeit. Eine Sitzung verpasst? Wir stellen Aufzeichnungen zum späteren Nachschauen bereit.",
    },
    {
      q: "Welche Programmiersprachen unterrichten Sie?",
      a: "Je nach Kurs: Python, JavaScript, HTML und CSS, React, Swift, Kotlin und SQL. Sie lernen die passenden Werkzeuge und Sprachen für das Gebiet, für das Sie sich weiterbilden.",
    },
    {
      q: "Wie kann ich mich für einen Kurs anmelden?",
      a: "Sehen Sie sich die verfügbaren Kurse an, wählen Sie den, der zu Ihrem Niveau passt, und melden Sie sich an. Sie erhalten alles, was Sie für den Start brauchen. Sie brauchen Hilfe bei der Auswahl? Unser Team unterstützt Sie gern.",
    },
    {
      q: "Stellen Sie Kurszertifikate aus?",
      a: "Ja. Nach dem Abschluss erhalten Sie ein Zertifikat, das Ihre neuen Fähigkeiten bestätigt, eine sinnvolle Ergänzung für Ihren Lebenslauf oder Ihr Portfolio.",
    },
    {
      q: "Wie lange dauern die Kurse?",
      a: "Die Dauer variiert je nach Thema. Manche sind intensiv und in wenigen Wochen abgeschlossen, andere erstrecken sich über mehrere Monate. Auf jeder Kursseite ist der zeitliche Aufwand angegeben.",
    },
    {
      q: "Was ist, wenn ich während des Kurses Fragen habe?",
      a: "Die Live-Kurse sind interaktiv, stellen Sie Ihre Fragen also jederzeit. Es gibt außerdem Unterstützung außerhalb des Unterrichts über das Community-Forum und Einzelgespräche.",
    },
  ],
};

export default de;
